import { render } from "./StyledInfoBox.vue?vue&type=template&id=54dca9c8&scoped=true"
import script from "./StyledInfoBox.vue?vue&type=script&lang=js"
export * from "./StyledInfoBox.vue?vue&type=script&lang=js"

import "./StyledInfoBox.vue?vue&type=style&index=0&id=54dca9c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dca9c8"]])

export default __exports__